"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("mktDashboardCreateFavoritePopinCtrl", function ($scope, $q, indexationService, mktDashboardService, customIndexationService, fixingService) {
  var ctrl = this;
  ctrl.reference = {
    type: "INDEX",
    indexId: null,
    indexationId: null
  };
  function initialize() {
    $q.when(indexationService.getIndicesClient()).then(function (indices) {
      ctrl.indices = indices;
    });
    $q.when(customIndexationService.fetchIndexations()).then(function (indexations) {
      ctrl.indexations = indexations;
    });
  }
  ctrl.saveFavorite = function () {
    ctrl.error = null;
    if (fixingService.isValidReference(ctrl.reference)) {
      mktDashboardService.createFavorite(ctrl.reference).then(function (favorite) {
        $scope.$close(favorite);
      });
    } else {
      ctrl.error = "Veuillez choisir l'indice ou l'indexation";
    }
  };
  initialize();
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/dashboard/mkt-dashboad-create-favorite-popin.js
// module id = 2837
// module chunks = 13